export const getStyled = (theme) => ({
  root: {
    width: '100%',
  },

  mainPaper: {
    width: '100%',
    flex: 1,
    padding: theme.spacing(2),
    backgroundColor: theme.custom.colors.defaultBackground,

    borderColor: theme.palette.mode === 'light' ? '#192734' : '#8C939A',
    color: ` ${theme.custom.colors.text} !important`,

    '& .MuiTableCell-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiTypography-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiIconButton-root': {
      color: `${theme.custom.colors.text} !important`,
    },
    '& .MuiAvatar-root': {
      color: `${theme.custom.colors.text} !important`,
    },
  },

  fullWidth: {
    width: '100%',
  },

  tableContainer: {
    width: '100%',
    padding: 5,
    overflowX: 'auto',
    ...theme.custom.scrollbarStyles,
    backgroundColor: theme.custom.colors.defaultBackground,
  },

  row: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },

  control: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },

  buttonContainer: {
    textAlign: 'right',
    padding: theme.spacing(1),
  },
});
